export var RateLimitFlows;
(function (RateLimitFlows) {
    RateLimitFlows["CREATE_CHATBOT"] = "CreateChatbot";
    RateLimitFlows["TRANSLATE_CHATBOT"] = "TranslateChatbot";
    RateLimitFlows["REPORT_CHATBOT"] = "ReportChatbot";
    RateLimitFlows["REPORT_LOREBOOK"] = "ReportLorebook";
    RateLimitFlows["CHAT"] = "Chat";
    RateLimitFlows["GENERATE_IMAGE"] = "GenerateImage";
    RateLimitFlows["GENERATE_CONVERSATION_IMAGE"] = "GenerateConversationImage";
    RateLimitFlows["UPLOAD_USER_IMAGE"] = "UploadUserImage";
    RateLimitFlows["SUBSCRIBE"] = "Subscribe";
    RateLimitFlows["SUGGEST_FIELD"] = "SuggestField";
    RateLimitFlows["SUGGEST_TAGS"] = "SuggestTags";
    RateLimitFlows["PLAY_MESSAGE_AUDIO"] = "PlayMessageAudio";
})(RateLimitFlows || (RateLimitFlows = {}));
export var ModerationFlows;
(function (ModerationFlows) {
    ModerationFlows["CREATE_CHATBOT"] = "CreateChatbot";
    ModerationFlows["UPDATE_CHATBOT"] = "UpdateChatbot";
    ModerationFlows["CREATE_PERSONA"] = "CreatePersona";
    ModerationFlows["UPDATE_PERSONA"] = "UpdatePersona";
    ModerationFlows["UPDATE_USER"] = "UpdateUser";
    ModerationFlows["GENERATE_CONVERSATION_IMAGE"] = "GenerateConversationImage";
    ModerationFlows["GENERATE_IMAGE"] = "GenerateImage";
    ModerationFlows["UPLOAD_USER_IMAGE"] = "UploadUserImage";
})(ModerationFlows || (ModerationFlows = {}));
